exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-card-component .el-card__header{padding:0px !important}\n", ""]);

// exports
